// @flow

// DataTable Module
import datatable from './datatable'

// Operator State
import { initialState as operatorState } from 'hfty-operator-asset'

// how does this fit in with asset operator?
import { initialState as fieldBorderOperatorState } from 'fc-operator-fieldborder'

// Constants
import {
  TABLE_BRANCH,
} from './constants'

export default {
  [TABLE_BRANCH]: datatable.initialState,
  ...operatorState,
  ...fieldBorderOperatorState,
}
